@keyframes slide {
    0% {
        transform: translateY(100%);
    }
    100% {
        transform: translateY(0);
    }
}

@keyframes dismiss {
    0% {
        transform: translateY(0);
        opacity: 1;
    }
    100% {
        transform: translateY(100%);
        opacity: 0;
    }
}

.baseNotification {
    background: linear-gradient(to right, var(--mantine-color-primary-8), var(--mantine-color-primary-5));
    outline: var(--mantine-color-primary-3) solid 2px;
    padding: 0.5rem 0.5rem;
    border-radius: 0.5rem;
    z-index: var(--mantine-priority-highest);
    justify-content: space-between;
    align-items: center;
}

.opened {
    animation: slide 200ms linear forwards;
}

.dismissed {
    animation: dismiss 200ms linear forwards;
}

.alignSelfStart {
    align-self: start;
}

.alignSelfEnd {
    align-self: end;
}
